import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CartUIState, CartUIStore } from '@/features/cart/types/cart.types';

// Re-export types for backward compatibility
;

const initialState: CartUIState = {
  isDrawerOpen: false,
  pendingItemId: null,
  isAddingToCart: false,
  lastAddedItemId: null,
  showSuccessAnimation: false,
};

export const useCartStore = create<CartUIStore>()(
  devtools(
    (set) => ({
      ...initialState,

      // Drawer controls
      openDrawer: () => set({ isDrawerOpen: true }, false, 'openDrawer'),
      closeDrawer: () => set({ isDrawerOpen: false }, false, 'closeDrawer'),
      toggleDrawer: () => set(
        (state) => ({ isDrawerOpen: !state.isDrawerOpen }),
        false,
        'toggleDrawer'
      ),

      // Pending state
      setPendingItem: (id) => set({ pendingItemId: id }, false, 'setPendingItem'),
      setAddingToCart: (isAdding) => set({ isAddingToCart: isAdding }, false, 'setAddingToCart'),

      // Success feedback
      setLastAddedItem: (id) => set({ lastAddedItemId: id }, false, 'setLastAddedItem'),
      triggerSuccessAnimation: () => {
        set({ showSuccessAnimation: true }, false, 'triggerSuccessAnimation');
        // Auto-reset after animation
        setTimeout(() => {
          set({ showSuccessAnimation: false }, false, 'resetSuccessAnimation');
        }, 2000);
      },

      // Reset
      reset: () => set(initialState, false, 'reset'),
    }),
    { name: 'cart-ui-store' }
  )
);

// Selector hooks for common use cases
export const useOpenCartDrawer = (): (() => void) => useCartStore((s) => s.openDrawer);
export const useCloseCartDrawer = (): (() => void) => useCartStore((s) => s.closeDrawer);

// Selector functions for flexible store access
